import React, {
  useContext, useEffect, useState,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CSVLink } from 'react-csv';
import { useHistory } from 'react-router';

import SamplePlotsMap from '../../../Map/components/SamplePlotsMap';
import CustomInput from '../../../../generic/CustomInput';
import CustomBtn from '../../../../generic/CustomBtn';
// import WrapperScaleImg from '../../../WrapperScaleImg/WrapperScaleImg';
import { ALL_REPORT_TYPE, SUB_REPORT_TYPE } from '../../../../constans/constans';
import MapMini from '../../../Map/components/MapMini/MapMini';
import { chooseReUpdateData } from '../../../../utils/api-request';
import { appStore } from '../../../../state/app';

const SampleZones = ({ totalData, setTotalData, prevPage, currentStage, handleUpdateProject, numberSampleZones, projectReportType, firstDataUpload, fieldAgentExist }) => {
  const history = useHistory();
  const { state } = useContext(appStore);
  const { account } = state;
  const defaultCoordinate = {
    region: totalData.region,
    polygon: totalData.polygon,
    stagesInfo: totalData.stagesInfo || [],
    subZones: totalData.subZones || [],
    sampleZones: totalData.sampleZones || [],
    codePlus: totalData.codePlus,
    polygonCoordinate: totalData.polygonCoordinate,
    square: totalData.square,
  };
  const [coordinate, setCoordinate] = useState(defaultCoordinate);
  const [showSampleMap, setShowSampleMap] = useState(false);
  const [sampleZonesChanged, setSampleZonesChanged] = useState([]);
  const [warning, setWarning] = useState({ type: '', msg: '' });
  const translate = useIntl();
  const currentStageInfo = coordinate.stagesInfo.find((item) => item.stage === currentStage);
  const currentSubZone = coordinate.subZones.find((item) => item.subId === currentStageInfo?.subId);
  const currentSampleZones = coordinate.sampleZones.filter((item) => item.subId === currentSubZone?.subId);

  const [treeDensity, setTreeDensity] = useState(currentSubZone?.treeDensity ? currentSubZone.treeDensity : '');
  const [sampleRadius, setSampleRadius] = useState({ value: currentSubZone?.sampleRadius ? currentSubZone.sampleRadius : 0, savedValue: 0, savedTreeDensity: 0 });
  const [upperAttempCellSide, setUpperAttempCellSide] = useState({ value: 0, isDraw: false });
  const isPreviousZone = () => {
    const duplicates = coordinate.stagesInfo.filter((item) => item.subId === currentStageInfo?.subId);
    if (duplicates.length > 1) return true;
    return false;
  };

  const calculateRadius = (tDensity) => {
    const param1 = 20;
    const param2 = 1e4;
    if (+currentSubZone.square >= 0.2 && +currentSubZone.square < 1) return 11;
    if (tDensity) {
      const r = Math.ceil(Math.sqrt(((param1 / +tDensity) * param2) / Math.PI));
      if (r <= 8) return 8;
      return r;
    }
    return 0;
  };

  const handleChangeTreeDensity = (e) => {
    const value = e.target.value;
    const radius = calculateRadius(value);
    setTreeDensity(value);
    setSampleRadius({
      ...sampleRadius,
      value: radius,
    });
    if (+value < 200 && !!value) {
      setWarning({
        type: 'treeDensityW',
        msg: 'dataUploadWizard.sampleZone.warningTree3',
      });
    } else {
      setWarning({ type: '', msg: '' });
    }
  };
  const handleClickNext = async () => {
    if (fieldAgentExist) {
      history.push('/');
    } else {
      if (!treeDensity) {
        setWarning({
          type: 'treeDensity',
          msg: translate.formatMessage({ id: 'dataUploadWizard.sampleZone.warningTree' }),
        });
        return;
      }
      if (!isPreviousZone()) {
        if ((treeDensity !== sampleRadius.savedTreeDensity) || isPreviousZone()) {
          setWarning({
            type: 'treeDensity',
            msg: translate.formatMessage({ id: 'dataUploadWizard.sampleZone.warningTree2' }),
          });
          return;
        }
      }

      if (currentSampleZones.length === numberSampleZones) {
        const updTotalData = await chooseReUpdateData(totalData.project_id, account, { ...totalData });
        // Add sampleRadius and treeDensity to subZone
        if (!isPreviousZone()) {
          const updSubZone = { ...currentSubZone, sampleRadius: sampleRadius.value, treeDensity };
          updTotalData.subZones.pop();
          updTotalData.subZones.push(updSubZone);

          const updCurrentSampleZones = currentSampleZones.map((item) => ({ ...item, sampleRadius: sampleRadius.value, treeDensity }));
          const updSampleZones = updTotalData.sampleZones.filter((item) => item.subId !== currentStageInfo.subId);
          updSampleZones.push(...updCurrentSampleZones);
          updTotalData.sampleZones = [...updSampleZones];
        }

        // Project's report type defines only during first report ever (after self upload)
        if (firstDataUpload) updTotalData.projectReportType = projectReportType;

        setWarning({ type: '', msg: '' });
        handleUpdateProject(updTotalData);
      } else {
        setWarning({
          type: 'sampleZones',
          msg: translate.formatMessage({ id: 'dataUploadWizard.sampleZone.warningNumber' }),
        });
      }
    }
  };

  const placeSamplePlots = () => {
    // eslint-disable-next-line no-debugger
    if (!treeDensity) {
      setWarning({
        type: 'treeDensity',
        msg: translate.formatMessage({ id: 'dataUploadWizard.sampleZone.warningTree' }),
      });
      return;
    } if (+treeDensity < 200) {
      setWarning({
        type: 'treeDensityW',
        msg: 'dataUploadWizard.sampleZone.warningTree3',
      });

      setShowSampleMap(true);
      return;
    }
    setWarning({ type: '', msg: '' });
    if (sampleRadius.value !== sampleRadius.savedValue) {
      setUpperAttempCellSide({
        value: 0,
        isDraw: false,
      });
    }
    setShowSampleMap(true);
  };

  const getHtmlView = (firstUpload, type) => {
    const firstView = (
      <>
        <h3 className="upload-wizard__sample-header">
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establish' })}
        </h3>
        <FormattedMessage
          id="dataUploadWizard.sampleZone.establish-description"
          values={{
            div: (...chunks) => <div className="upload-wizard__sample-text">{chunks}</div>,
            p: (chunks) => <p>{chunks}</p>,
          }}
        />
        <div className="upload-wizard__sample-info">
          <CustomInput
            type="text"
            label={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establishInput-label' })}
            placeholder={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establishInput-placeholder' })}
            customClass="upload-wizard__sample-value"
            customClassLabel="upload-wizard__density-label"
            value={treeDensity}
            error={warning.type === 'treeDensity' || warning.type === 'treeDensityW'}
            onlyNumber
            change={handleChangeTreeDensity}
          />
          <div className="upload-wizard__sample-plots">
            <span>
              {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.newSamplePlots' })}
            </span>
            <p className="upload-wizard__sample-value">
              {numberSampleZones}
            </p>
          </div>
        </div>
        <div className="upload-wizard__sample-action">
          <CustomBtn
            label={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.placeSamplePlots' })}
            handleClick={() => placeSamplePlots()}
            customClass="upload-wizard__place"
          />
        </div>
      </>
    );

    const secondView = (
      <>
        <h3 className="upload-wizard__sample-header">
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.reviewSamplePlots' })}
        </h3>
        <FormattedMessage
          id="dataUploadWizard.sampleZone.reviewSamplePlots-description"
          values={{
            p: (...chunks) => <p className="upload-wizard__sample-text">{chunks}</p>,
            br: <br />,
          }}
        />
      </>
    );

    const thirdView = (
      <>
        <h3 className="upload-wizard__sample-header">
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.reviewSamplePlots' })}
        </h3>
        <p className="upload-wizard__sample-text">
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.reviewSamplePlots-description2' })}
        </p>
      </>
    );

    const fourthView = (
      <>
        <h3 className="upload-wizard__sample-header">
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establish' })}
        </h3>
        <FormattedMessage
          id="dataUploadWizard.sampleZone.establish-description2"
          values={{
            div: (...chunks) => <div className="upload-wizard__sample-text">{chunks}</div>,
            p: (chunks) => <p>{chunks}</p>,
          }}
        />
        <div className="upload-wizard__sample-info">
          <CustomInput
            type="text"
            label={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establishInput-label' })}
            placeholder={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.establishInput-placeholder' })}
            customClass="upload-wizard__sample-value"
            customClassLabel="upload-wizard__density-label"
            value={treeDensity}
            error={warning.type === 'treeDensity' || warning.type === 'treeDensityW'}
            onlyNumber
            change={handleChangeTreeDensity}
          />
          <div className="upload-wizard__sample-plots">
            <span>
              {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.newSamplePlots' })}
            </span>
            <p className="upload-wizard__sample-value">
              {numberSampleZones}
            </p>
          </div>
        </div>
        <div className="upload-wizard__sample-action">
          <CustomBtn
            label={translate.formatMessage({ id: 'dataUploadWizard.sampleZone.placeSamplePlots' })}
            handleClick={() => placeSamplePlots()}
            customClass="upload-wizard__place"
          />
        </div>
      </>
    );

    if (fieldAgentExist) {
      return thirdView;
    }

    if (firstUpload) {
      return type === ALL_REPORT_TYPE ? fourthView : firstView;
    }

    if (type === SUB_REPORT_TYPE) {
      return isPreviousZone() ? secondView : firstView;
    }

    if (type === ALL_REPORT_TYPE) {
      return secondView;
    }
  };

  useEffect(() => {
    setTotalData({ ...totalData, ...coordinate });
  }, [coordinate]);
  return (
    <div className="upload-wizard__sample">
      {getHtmlView(firstDataUpload, projectReportType)}
      {showSampleMap && (
        <SamplePlotsMap
          state={coordinate}
          setState={setCoordinate}
          setShow={setShowSampleMap}
          currentStage={currentStage}
          numberSampleZones={numberSampleZones}
          sampleZonesChanged={sampleZonesChanged}
          setSampleZonesChanged={setSampleZonesChanged}
          sampleRadius={sampleRadius}
          setSampleRadius={setSampleRadius}
          treeDensity={treeDensity}
          upperAttempCellSide={upperAttempCellSide}
          setUpperAttempCellSide={setUpperAttempCellSide}
        />
      )}
      {!showSampleMap && (
      <MapMini
        state={coordinate}
      />
      )}
      {!!currentSampleZones?.length && (
        <CSVLink
          data={
            totalData.sampleZones.map((el) => [
              `samplePlot: ${el.sampleName}`,
              `longitude: ${el.coordinates[0]}`,
              `latitude: ${el.coordinates[1]}`,
            ])
          }
          filename="Coordinate"
          className="upload-wizard__sample-download btn"
        >
          {translate.formatMessage({ id: 'dataUploadWizard.sampleZone.downloadSamplePlotCoordinates' })}
        </CSVLink>
      )}
      {warning.type === 'treeDensityW' && (
      <div className="upload-wizard__amoutnt-warning ">
        <span>
          <FormattedMessage
            id={warning.msg}
            values={{ b: (chunks) => <b>{chunks}</b> }}
          />
        </span>
      </div>
      )}

      <div className="upload-wizard__sample-footer">
        {warning.type !== 'treeDensityW' && <span className="upload-wizard__sample-warning">{warning.msg}</span>}
        <CustomBtn
          label={translate.formatMessage({ id: 'button-back' })}
          handleClick={prevPage}
          type="button"
          customClass="btn__cancel"
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-save' })}
          handleClick={handleClickNext}
          type="submit"
          customClass="btn__btn-next"
        />
      </div>
    </div>
  );
};

export default SampleZones;
